import { useEffect, useState } from 'react'
import { VehiclePageNumber, OptionsPageNumber, AftermarketPageNumber, HistoryPageNumber } from '../../constants'
import { useReRenderer, useScroller } from '..'

const scrollTarget = (isError, vehicleErrors) => isError && `#${Object.keys(vehicleErrors).find(error => vehicleErrors[error])}-error`

const singleOptionArray = (engines = [], transmissions = [], drivetrains = []) =>
  []
    .concat(engines.length === 1 ? { ...engines[0], optionId: engines[0].engineId, userIsSelected: true, isDisabled: false, locked: true } : [])
    .concat(transmissions.length === 1 ? { ...transmissions[0], optionId: transmissions[0].transmissionId, userIsSelected: true, isDisabled: false, locked: true } : [])
    .concat(drivetrains.length === 1 ? { ...drivetrains[0], optionId: drivetrains[0].drivetrainId, userIsSelected: true, isDisabled: false, locked: true } : [])

const displayOrderArray = (trimIsEligible, engines, transmissions, drivetrains, colors, optionsVinVerified) => [
  { component: 'InfoImage', displayProp: () => true, title: '', subtitle: '' },
  { component: 'Color', displayProp: () => trimIsEligible && colors && colors.length > 1, title: 'Select Color', subtitle: 'Colors may not exactly match your vehicle.' },
  {
    component: 'Engine',
    displayProp: () => {
      return (trimIsEligible && engines && engines.length > 1) || (trimIsEligible && engines && engines.length >= 1 && engines[0].isIneligible)
    },
    title: 'Select Engine',
    subtitle: ''
  },
  {
    component: 'Transmission',
    displayProp: () => {
      return (trimIsEligible && transmissions && transmissions.length > 1) || (trimIsEligible && transmissions && transmissions.length >= 1 && transmissions[0].isIneligible)
    },
    title: 'Select Transmission',
    subtitle: ''
  },
  {
    component: 'Drivetrain',
    displayProp: () => {
      return (trimIsEligible && drivetrains && drivetrains.length > 1) || (trimIsEligible && drivetrains && drivetrains.length >= 1 && drivetrains[0].isIneligible)
    },
    title: 'Select Drivetrain',
    subtitle: ''
  },
  { component: 'Options', displayProp: () => trimIsEligible && !optionsVinVerified, title: 'Select Features & Equipment', subtitle: '' },
  { component: 'TwoMoreKeysQuestion', displayProp: () => true, title: 'Do you have 2 or more keys or keyless remotes?', subtitle: '' },
  { component: 'VehicleModifications', displayProp: () => true, title: 'Has your vehicle had any modifications?', subtitle: '(Example: custom wheels/tires, suspension kit, upgraded stereo)' }
]

export default ({ trim, color, transmission, engine, drivetrain, mileage, eligibility, experienceState, updateGlobalState, urlState, ...props }) => {
  var { offer, engines, transmissions, drivetrains, colors, getHasVehicleModifications, getSelectedVehicleModifications } = props
  const { isAssigned, isIneligibleVehiclesEnabled } = experienceState
  let optionsVinVerified = false
  if (props.vinResults) {
    optionsVinVerified = props.vinResults.optionsVinVerified
  }
  const [reRender, random] = useReRenderer()
  const [isError, setError] = useState(false)
  const [setHasScrolled, scroll] = useScroller()
  const vehicleErrors = {
    infoimage: props.renewErrors && props.renewErrors.length > 0,
    trim: !trim,
    mileage: !mileage || !(mileage && mileage > 0) || ((isIneligibleVehiclesEnabled ? !isAssigned : true) && mileage > 300000),
    color: !color,
    transmission: !transmission || ((isIneligibleVehiclesEnabled ? !isAssigned : true) && transmission && transmission.isIneligible),
    engine: !engine || ((isIneligibleVehiclesEnabled ? !isAssigned : true) && engine && engine.isIneligible),
    drivetrain: !drivetrain || ((isIneligibleVehiclesEnabled ? !isAssigned : true) && drivetrain && drivetrain.isIneligible),
    twomorekeysquestion: props.getQuestionResponse('qp/79').v === undefined,
    vehiclemodifications: getHasVehicleModifications() === undefined
  }

  const nextDisabled =
    Object.values(vehicleErrors).reduce((acc, cur) => acc || cur, false) || (eligibility && !eligibility.isEligible && (isIneligibleVehiclesEnabled ? !isAssigned : true)) || ((isIneligibleVehiclesEnabled ? !isAssigned : true) && mileage > 300000)
  const error = () => {
    setError(true)
    setHasScrolled(false)
    reRender()
    updateGlobalState({ fireAnalytics: 'continue_error' })
  }

  let nextStep = getHasVehicleModifications() ? AftermarketPageNumber : HistoryPageNumber
  nextStep = ![VehiclePageNumber, OptionsPageNumber].includes(urlState.p) ? urlState.p : nextStep

  const isIneligible = process.env.BUILD_STAGE !== 'build-html' && (eligibility ? !eligibility.isEligible : false)
  const trimIsEligible = trim && (!isIneligible || (isIneligibleVehiclesEnabled ? isAssigned : false))
  const vin = urlState.vin || (offer && offer.prospect.vehicle.vin)
  const disabledArray = [
    false,
    false,
    false,
    engine && engine.isIneligible && (isIneligibleVehiclesEnabled ? !isAssigned : true),
    transmission && transmission.isIneligible && (isIneligibleVehiclesEnabled ? !isAssigned : true),
    drivetrain && drivetrain.isIneligible && (isIneligibleVehiclesEnabled ? !isAssigned : true)
  ]
  const singleOption = singleOptionArray(engines, transmissions, drivetrains)
  const displayOrder = displayOrderArray(trimIsEligible, engines, transmissions, drivetrains, colors, optionsVinVerified)
  const showModal = getHasVehicleModifications() === false && !!getSelectedVehicleModifications().length

  const targetElement = scrollTarget(isError, vehicleErrors)
  useEffect(() => {
    if (isError && targetElement) {
      scroll(targetElement)
    } else {
      scroll('body', 'top')
    }
    setHasScrolled(true)
  }, [isError, targetElement])

  return {
    displayOrder,
    disabledArray,
    singleOption,
    vin,
    isError,
    vehicleErrors,
    nextStep,
    random,
    nextDisabled,
    error,
    showModal
  }
}
